import * as moment from 'moment';

export const parseDate = moment as any;